<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import "@/assets/css/default.css";
import "@/assets/images/sprite.css";

export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@import "./assets/css/common.scss";
@import "./assets/css/megexicon.css";
@import "./assets/css/iconfont.css";
#app {
  min-width: 1200px;
}
</style>
